// const API_BASE_URL = "http://202.10.42.67/api/auth";
// const API_BASE_URL = "http://localhost:5000/api/auth";
// const API_BASE_URL = "http://103.82.93.177:5000/api/auth"; API lama
const API_BASE_URL = "/api/auth";


// fetch data user di user dashboard
export async function getUserData(token) {
  try {
    const response = await fetch(`${API_BASE_URL}/me`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    if (!response.ok) throw new Error("Gagal fetch user");

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error saat mengambil data user:", err);
    throw err;
  }
}

// api untuk login user
export async function loginUser({ phone, password }) {
  const response = await fetch(`${API_BASE_URL}/loginuser`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ phone, password }),
  });

  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.msg || "Login gagal");
    error.response = data;
    throw error;
  }

  return data;
}

// api untuk buat akun nasabah
export async function registerUserNasabah({ nama, password, nik, phone, token }) {
  const formData = new FormData();
  formData.append("username", nama);
  formData.append("password", password);
  formData.append("nik", nik);
  formData.append("phone", phone);

  const response = await fetch(`${API_BASE_URL}/register`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.msg || "Gagal membuat akun");
    error.response = data;
    throw error;
  }

  return data;
}

// api untuk mengambil semua user
export async function fetchUsers(token) {
  const res = await fetch(`${API_BASE_URL}/users`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) throw new Error("Gagal mengambil daftar pengguna");
  return res.json();
}

// api untuk menambahkan pembayaran ke user
export async function tambahPembayaran(data, token) {
  const res = await fetch(`${API_BASE_URL}/tambah-pembayaran`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: data,
  });

  const result = await res.json();
  if (!res.ok) {
    throw new Error(result.msg || "Gagal menambahkan pembayaran.");
  }
  return result;
}

// api untuk list users di list akun nasabah
const getToken = () =>
  localStorage.getItem("adminToken") || sessionStorage.getItem("adminToken");

export const ListUsers = async () => {
  const res = await fetch(`${API_BASE_URL}/users-full`, {
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  if (!res.ok) throw new Error("Failed to fetch users");
  return res.json();
};

// api untuk update user data di list akun nasabah
export const updateUser = async (userId, updatedData) => {
  const res = await fetch(`${API_BASE_URL}/update-user/${userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
    },
    body: JSON.stringify(updatedData),
  });
  if (!res.ok) throw new Error("Failed to update user");
  return res.json();
};

// api untuk login admin
export const loginAdmin = async (adminId, password) => {
  try {
    const res = await fetch(`${API_BASE_URL}/loginadmin`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ adminId, password }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.msg || "Login gagal");
    }

    return data;
  } catch (err) {
    throw new Error(err.message || "Gagal terhubung ke server");
  }
};

// api untuk mengambil data user dengan tagihan pada tagihan tabel
export const getUsersWithTagihan = async (token) => {
  const res = await fetch(`${API_BASE_URL}/users-with-tagihan`, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });
  if (!res.ok) throw new Error("Gagal fetch users dengan tagihan");
  return res.json();
};

//api untuk update tagihan pada tagihan tabel
export const updateTagihan = async (id, data, token) => {
  const res = await fetch(`${API_BASE_URL}/tagihan/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Gagal mengupdate tagihan");
  return res.json();
};

// api untuk hapus user
export const deleteUser = async (userId) => {
  const token = localStorage.getItem("adminToken") || sessionStorage.getItem("adminToken");
  const res = await fetch(`${API_BASE_URL}/user/${userId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) throw new Error("Gagal hapus user");
  return res.json();
};

// api untuk upadate foto
export const updateTagihanFoto = async (id, formData, token) => {
  const res = await fetch(`${API_BASE_URL}/tagihan/foto/${id}`, {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: formData,
  });
  if (!res.ok) throw new Error("Gagal update foto tagihan");
  return res.json();
};